import { language } from './language'

export type Forms = readonly string[]

export const pluralForm = (count: number, forms: Forms): string => {
  if (language !== 'ru') return (count === 1 ? forms[0] : forms[1]) ?? ''

  const tail = Math.abs(count) % 100
  const last = tail % 10
  if (tail > 10 && tail < 20) return forms[2] ?? forms[1] ?? ''
  if (last === 1) return forms[0] ?? ''
  if (last >= 2 && last <= 4) return forms[1] ?? ''
  return forms[2] ?? forms[1] ?? ''
}

export const counted = (count: number, forms: Forms): string =>
  `${count} ${pluralForm(count, forms)}`
